module.exports = __webpack_public_path__ + "img/input-numbers.80d945d2.png";